import React from 'react'
import {ProcesosPoliticas} from "../components/lineamientos/ProcesosPoliticas";

export const ProcesosPoliticasPage = () => {
    return (
        <ProcesosPoliticas/>
    )
}
